// Shared helpers for the "Suivi des chantiers" feature.
// Extracted from WorkTrackingTab.jsx to keep that component focused on layout.

import { toYMD } from "@/lib/api";

export const TYPE_COLORS = {
  commande: "bg-green-500",
  sav: "bg-red-500",
  fournisseur: "bg-blue-500",
  atelier: "bg-purple-500",
  custom: "bg-gray-500",
};

export const TYPE_LABELS = {
  commande: "Commande",
  sav: "SAV",
  fournisseur: "Fournisseur",
  atelier: "Atelier",
  custom: "Autre",
};

export const TYPE_COLORS_LIGHT = {
  commande: "bg-green-100 text-green-800 border-green-300",
  sav: "bg-red-100 text-red-800 border-red-300",
  fournisseur: "bg-blue-100 text-blue-800 border-blue-300",
  atelier: "bg-purple-100 text-purple-800 border-purple-300",
  custom: "bg-gray-100 text-gray-800 border-gray-300",
};

export const DAY_NAMES = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

export function getWeekDates(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(d.setDate(diff));
  const days = [];
  for (let i = 0; i < 5; i++) {
    const dd = new Date(monday);
    dd.setDate(monday.getDate() + i);
    days.push(dd);
  }
  return days;
}

export function getMonthDates(year, month) {
  const days = [];
  const d = new Date(year, month, 1);
  while (d.getMonth() === month) {
    if (d.getDay() !== 0 && d.getDay() !== 6) days.push(new Date(d));
    d.setDate(d.getDate() + 1);
  }
  return days;
}

export function dateStr(d) {
  return toYMD(d);
}

// Default morning/afternoon time slots — winter or summer schedule.
export function getDefaultSlots(d) {
  const oneJan = new Date(d.getFullYear(), 0, 1);
  const days = Math.floor((d - oneJan) / 86400000);
  const week = Math.ceil((days + oneJan.getDay() + 1) / 7);
  if (week >= 13 && week <= 39) {
    return { morning: { start: "07:00", end: "12:00" }, afternoon: { start: "13:00", end: "16:12" } };
  }
  return { morning: { start: "08:00", end: "12:00" }, afternoon: { start: "13:00", end: "16:12" } };
}
